import { OrderStatus } from "../../../../core/schema/OrderStatus.js";

export const orderStatusTextColorMap: Record<OrderStatus, string> = {
	[OrderStatus.Accepted]: "text-themeBlue",
	[OrderStatus.Manufactured]: "text-themeBlue",
	[OrderStatus.ReadyForPickup]: "text-orange",
	[OrderStatus.Delivered]: "text-tertiary",
	[OrderStatus.Cancelled]: "text-primary",
};
